import React, { Fragment } from "react";
import {
  HtmlEditor,
  Image,
  Inject,
  Link,
  QuickToolbar,
  RichTextEditor,
  RichTextEditorComponent,
  Toolbar,
} from "@syncfusion/ej2-react-richtexteditor";
import { Label } from "../../../components/InputField1/InputFiled1Style";

const Editor = ({ state, setState, label }) => {
  const DefaultOptionImg = {
    allowedTypes: [".jpeg", ".jpg", ".png"],
    display: "inline",
    width: "auto",
    height: "auto",
    saveFormat: "Base64",
    saveUrl: "https://ej2.syncfusion.com/services/api/uploadbox/Save",
  };

  const handleChange = (e) => {
    setState(e.value);
  };

  return (
    <Fragment>
      {label ? <Label>{label}</Label> : null}
      <RichTextEditorComponent
        value={state}
        change={handleChange}
        enableAutoUrl={true}
        locale={"ir-IR"}
        placeholder={"توضیحات را وارد نمایید"}
        insertImageSettings={DefaultOptionImg}
        enableHtmlSanitizer={false}
      >
        <Inject services={[HtmlEditor, Toolbar, Image, Link, QuickToolbar]} />
      </RichTextEditorComponent>
    </Fragment>
  );
};

export default Editor;
